<div class="search--navbar">
    <ul class="search--navbar__list">
        <li class="search--navbar__item1">
            <div class="search--navbar__item1__switch">
                <toggle-switch [option1]="'Customer'" [option2]="'Vehicle'" (selectedOption)="searchSelected($event)">
                    <i class="material-icons" option1>person</i>
                    <i class="material-icons" option2>directions_car</i>
                </toggle-switch>
            </div>
        </li>
        <li class="search--navbar__item2">
            <div class="search--navbar__item2__switch">
                <ng-container *ngIf="isCustomerSelected">
                    <search-criteria [context]="2" [placeholder]="'Customer Search...'"
                        [initialSearch]="commonSearchString"
                        (onSearchStringChanged)="searchStringChanged($event)"
                        (onResultsReceived)="customerReceiveResults($event)">
                    </search-criteria>
                </ng-container>
                <ng-container *ngIf="!isCustomerSelected">
                    <search-criteria [context]="1" [placeholder]="'Vehicle Search...'"
                        [initialSearch]="commonSearchString"
                        (onSearchStringChanged)="searchStringChanged($event)"
                        (onResultsReceived)="vehicleReceiveResults($event)"
                        (onSearchStringUsed)="vehicleSearchStringUsed($event)">
                    </search-criteria>
                </ng-container>
            </div>
        </li>
        <li class="search--navbar__item3">
            <a class="search__advanced" href="javascript:void(0)" (click)="advancedSearch()">Advanced Search</a>
        </li>
    </ul>
    <button class="btn--primary" title="Advanced Search" (click)="advancedSearch()">Search</button>
</div>